// extracted by mini-css-extract-plugin
export default {"dialog":"z5sabM8","headline":"XSA2Hwy","text":"YcuvU62","buttons":"v90And8","button":"SVt_IZ4"};